/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  PatientExternalReceiptInformation,
  PatientExternalReceiptInformationFromJSON,
  PatientExternalReceiptInformationToJSON,
} from "../models";

export interface GetExternalReceiptInformationRequest {
  patientId: number;
  chainId: number;
  familyAccountId?: number;
}

/**
 *
 */
export class ExternalReceiptInformationApi extends runtime.BaseAPI {
  /**
   * Retrieve and return receipt information from external services
   */
  async getExternalReceiptInformationRaw(
    requestParameters: GetExternalReceiptInformationRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PatientExternalReceiptInformation>> {
    if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
      throw new runtime.RequiredError(
        "patientId",
        "Required parameter requestParameters.patientId was null or undefined when calling getExternalReceiptInformation."
      );
    }

    if (requestParameters.chainId === null || requestParameters.chainId === undefined) {
      throw new runtime.RequiredError(
        "chainId",
        "Required parameter requestParameters.chainId was null or undefined when calling getExternalReceiptInformation."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.chainId !== undefined) {
      queryParameters["chain_id"] = requestParameters.chainId;
    }

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patients/{patient_id}/external-receipt-informations`.replace(
          `{${"patient_id"}}`,
          encodeURIComponent(String(requestParameters.patientId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PatientExternalReceiptInformationFromJSON(jsonValue));
  }

  /**
   * Retrieve and return receipt information from external services
   */
  async getExternalReceiptInformation(
    requestParameters: GetExternalReceiptInformationRequest,
    initOverrides?: RequestInit
  ): Promise<PatientExternalReceiptInformation> {
    return promiseRetry(
      (retry) =>
        this.getExternalReceiptInformationRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}
